/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Students_TitleInputs */

const en_students_title = /** @type {(inputs: Students_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students`)
};

const he_students_title = /** @type {(inputs: Students_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמידים`)
};

/**
* | output |
* | --- |
* | "Students" |
*
* @param {Students_TitleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const students_title = /** @type {((inputs?: Students_TitleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Students_TitleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_students_title(inputs)
	return he_students_title(inputs)
});